<top-banner variant="title" [title]="selectedWorkerName"></top-banner>

<div class="main-content manage-competencies-page">
  <div class="card animated fadeIn">
    <div class="row">
      <div class="col-md-2 cardtabs-wrapper">
        <app-card-tabs [tabitems]="tabitems" [backLink]="backLink ? { path: backLink, title: 'Back' } : null"></app-card-tabs>
      </div>

      <div class="col-md-10">
        <div class="card-body">
          <card-section-header title="Competencies" [icon]="canEditCompetencies ? 'fas fa-pen-to-square' : 'fas fa-list'" [showButton]="false"></card-section-header>

          <div *ngIf="shouldShowCompetencyGuidance" class="sl-info-card mb-4">
            <div class="sl-info-card__content">
              <div class="sl-info-card__title">
                <i class="fa-solid fa-circle-info sl-info-card__title-icon"></i>
                <span>Competency Guidance</span>
              </div>
              <div class="sl-info-card__body mb-0">
                <div *ngIf="shouldShowFullAtGuidance" class="mb-3">
                  <p class="mb-2"><strong>Unrestricted AT</strong></p>
                  <p class="mb-0">This worker has an unrestricted AT competency. Using OEM-specific AT competencies where appropriate can provide additional safety and control.</p>
                </div>
                <div *ngIf="shouldShowFullAtAndCtGuidance">
                  <p class="mb-2"><strong>Unrestricted AT and CT</strong></p>
                  <p class="mb-0">On Skylark, an Authorised Technician can now carry out Competent Technician work orders and procedures. Review whether this worker's CT competency is still required.</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="siteOwners.length > 1" class="mb-4">
            <label>Site Owner</label>
            <p-dropdown
              class="form-control"
              [(ngModel)]="selectedSiteOwner"
              [ngModelOptions]="{standalone: true}"
              [options]="siteOwners"
              (ngModelChange)="selectedSiteOwnerChange()"
              placeholder="Select a site owner..."
              [style]="{'width':'100%'}"
              filter="true"
            ></p-dropdown>
          </div>

          <ng-container *ngIf="siteOwnerId">
            <div *ngIf="!workerSiteAccessLoaded" class="temporary-information-message">
              <p-progressSpinner></p-progressSpinner>
              <p>Loading worker details...</p>
            </div>

            <div *ngIf="shouldShowWorkerSiteAccessMessage" class="sl-info-card">
              <div class="sl-info-card__content">
                <p class="sl-info-card__body">
                  <span class="sl-info-card__title">
                    <i class="fa-solid fa-circle-info sl-info-card__title-icon"></i>
                    <span>Add worker to a site</span>
                  </span>
                  {{ workerSiteAccessMessage }}
                </p>
                <a
                  *ngIf="shouldShowWorkerSitesLink"
                  class="btn btn-primary btn-round sl-info-card__cta"
                  [routerLink]="workerSitesLink"
                  [queryParams]="workerSitesQueryParams">
                  Go to worker's sites
                </a>
              </div>
            </div>

            <ng-container *ngIf="workerSiteAccessLoaded && workerHasVisibleSitesForSelectedOwner">
              <div *ngIf="isManagingSelfAsDelegate" class="sl-info-card">
                <div class="sl-info-card__content">
                  <p class="sl-info-card__body">
                    <span class="sl-info-card__title">
                      <i class="fa-solid fa-circle-info sl-info-card__title-icon"></i>
                      <span>These are your own competencies</span>
                    </span>
                    Add and submit evidence for them from My Competencies. Another Site Delegate or an Authorising Officer must approve them.
                  </p>
                  <a
                    class="btn btn-primary btn-round sl-info-card__cta"
                    [routerLink]="['/', routeRole, 'manage-competencies']">
                    Go to My Competencies
                  </a>
                </div>
              </div>

              <div class="compblock" *ngIf="canEditCompetencies">
                <h6>Add Competency</h6>
                <app-add-competency-form
                  [skylarkUserId]="selectedWorkerId"
                  [siteOwnerId]="siteOwnerId"
                  flowMode="standard"
                  approvalMode="privileged"
                  (competencyAdded)="loadCompetencies()">
                </app-add-competency-form>
              </div>

              <div class="compblock compblock--summary mt-4" *ngIf="shouldShowAuthorisationRestrictions">
                <div class="comp-summary-header">
                  <h6>Competency Restrictions</h6>
                  <div class="text-area-comp-btn" *ngIf="canEditAuthorisationRestrictions">
                    <ng-container *ngIf="authorisationNotes; else createButton">
                      <button
                        *ngIf="!summaryEditMode"
                        type="button"
                        class="btn btn-sm btn-round btn-outline-primary"
                        (click)="summaryEditMode = true">
                        <i class="now-ui-icons ui-2_settings-90"></i> Edit
                      </button>
                      <button
                        *ngIf="summaryEditMode"
                        type="button"
                        class="btn btn-sm btn-round btn-success"
                        [disabled]="summarySaving"
                        (click)="saveAuthorisationNotes()">
                        Save
                      </button>
                    </ng-container>
                    <ng-template #createButton>
                      <button
                        type="button"
                        class="btn btn-sm btn-round btn-success"
                        [disabled]="summaryCreating || !newAuthorisationNotesText || !newAuthorisationNotesText.trim()"
                        (click)="createAuthorisationNotes()">
                        Save
                      </button>
                    </ng-template>
                  </div>
                </div>
                <ng-container *ngIf="authorisationNotes; else missingAuthorisationNotes">
                  <textarea
                    rows="4"
                    class="text-area-comp-summary"
                    placeholder="Enter competency restrictions here..."
                    [readonly]="!canEditAuthorisationRestrictions || !summaryEditMode || summarySaving"
                    [(ngModel)]="authorisationNotes.competencyNotes">
                  </textarea>
                </ng-container>
                <ng-template #missingAuthorisationNotes>
                  <textarea
                    *ngIf="canEditAuthorisationRestrictions; else noRestrictionsReadonly"
                    rows="4"
                    class="text-area-comp-summary"
                    placeholder="Enter competency restrictions here..."
                    [disabled]="summaryCreating"
                    [(ngModel)]="newAuthorisationNotesText"
                    [ngModelOptions]="{standalone: true}">
                  </textarea>
                  <ng-template #noRestrictionsReadonly>
                    <textarea
                      rows="4"
                      class="text-area-comp-summary"
                      readonly>No competency restrictions set.</textarea>
                  </ng-template>
                </ng-template>
              </div>

              <div class="compblock mt-4">
                <h6>Existing Competencies</h6>

                <div class="competency-filters-row">
                  <div class="filter-flex-row">
                    <filter-toggle-group
                      label="Competency Status:"
                      [options]="statusButtons"
                      [value]="filters.status"
                      (valueChange)="setStatusFilter($event)">
                    </filter-toggle-group>

                    <filter-toggle-group
                      label="Competency Category:"
                      [options]="categoryButtons"
                      [value]="filters.category"
                      (valueChange)="setCategoryFilter($event)">
                    </filter-toggle-group>
                  </div>

                  <div class="my-site-toggle">
                    <label class="">Show all:</label>
                    <label class="my-site-toggle__switch">
                      <input type="checkbox" [checked]="showAllCompetencies" (change)="toggleMySiteFilter()">
                      <span class="my-site-toggle__slider"></span>
                    </label>
                    <span class="my-site-toggle__text">{{ competencyScopeToggleLabel }}</span>
                  </div>
                </div>

                <div class="d-flex justify-content-end">
                  <filter-summary-display [items]="activeFiltersSummary"></filter-summary-display>
                </div>

                <ng-container *ngIf="filteredCompetencies.length; else emptyCompetencies">
                  <div class="competency-card-grid">
                    <competency-card
                      *ngFor="let competency of filteredCompetencies"
                      [competency]="competency"
                      cardType="user-edit"
                      [userCanManageCompetencies]="canManageCompetency(competency)"
                      [siteOwnerId]="siteOwnerId"
                      (updated)="onCardUpdated($event)"
                      (delete)="onCardDeleted($event)">
                    </competency-card>
                  </div>
                </ng-container>

                <ng-template #emptyCompetencies>
                  <div class="empty-panel-state">
                    <p class="empty-panel-state__message">{{ emptyCompetenciesMessage }}</p>
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
